import React from 'react';
import {AbstractMapItem, MapInput} from '../MapItems/MapItems';
import './WDRIconItemPrognose.css';

function updateTempColor(temp) {
  const colorIndex = temp;

  let tempColor;

  if (colorIndex <= -15) {
    tempColor = '#75165B';
  } else if (colorIndex > -15 && colorIndex <= -10) {
    tempColor = '#00417B';
  } else if (colorIndex > -10 && colorIndex <= -5) {
    tempColor = '#006E9F';
  } else if (colorIndex > -5 && colorIndex <= 0) {
    tempColor = '#28A5A7';
  } else if (colorIndex > 0 && colorIndex <= 5) {
    tempColor = '#6AB165';
  } else if (colorIndex > 5 && colorIndex <= 12) {
    tempColor = '#A0C300';
  } else if (colorIndex > 12 && colorIndex <= 20) {
    tempColor = '#F49500';
  } else if (colorIndex > 20 && colorIndex <= 25) {
    tempColor = '#F26D00';
  } else if (colorIndex > 25 && colorIndex <= 30) {
    tempColor = '#E74100';
  } else {
    tempColor = '#E90000';
  }
  return tempColor;
}

export function WDRIconItemPrognose(props) {
  const item = props.item;
  const temperature = Object.keys(item.data)[0];
  const icon = Object.keys(item.data)[1];
  const dangerSign = Object.keys(item.data)[2];

  function updateIcon(iconIndex) {
    const icon = 'url("images/wdr/icons/wdr_' + iconIndex + '.gif")';

    return icon;
  }

  function createDangerIcon(dangerSign) {
    if (dangerSign) {
      const iconPath = 'url("images/wdr/danger/Schild_' + dangerSign + '.png")';
      return (
        <div className='danger-icon2' style={{backgroundImage: iconPath}}></div>
      );
    }
  }
  return (
    <AbstractMapItem {...props}>
      <div
        className='wdr-icon-item'
        style={{
          backgroundColor: updateTempColor(item.data.temperature.value),
          backgroundImage: item.ui.backgroundImage
        }}>
        {/* CREATE TEMP BOX */}
        <div className='map-item-input-wdr-temp-input-wrapper'>
          <MapInput
            item={item}
            data={{key: temperature, value: item.data[temperature].value}}
            callback={props.setValueInMap}
          />
        </div>
        {/* CREATE ICON BOX */}
        <div
          className='map-item-input-wdr-icon-input-wrapper'
          style={{
            backgroundImage: updateIcon(item.data.icon.value)
          }}>
          <MapInput
            item={item}
            data={{key: icon, value: item.data[icon].value}}
            callback={props.setValueInMap}
          />
        </div>

        {/* CREATE DANGER SIGN */}

        {createDangerIcon(item.data.dangerSign.value)}

        <div className='danger-checkbox2'>
          <MapInput
            item={item}
            data={{key: dangerSign, value: item.data[dangerSign].value}}
            callback={props.setValueInMap}
          />
        </div>
      </div>
    </AbstractMapItem>
  );
}
